import { DateTime } from 'luxon';
import type { ReactNode } from 'react';
import ProjectPricingTable from '../ProjectPricingTable';

export type Announcement = {
  name: Announcements;
  content: AnnouncementContent[];
  buttons: {
    name: string;
    link: string;
    linkType: 'internal' | 'external';
  }[];
  modalClassName?: string;
  expiration?: DateTime;
};

type ContentBase = {
  title: string;
  message: ReactNode;
};

export type BulletItem = {
  title: string;
  bullets: string[];
};

export type AnnouncementContent =
  | (ContentBase & { type: 'jsx'; content: ReactNode })
  | (ContentBase & { type: 'loom'; content: string })
  | (ContentBase & { type: 'image'; content: string })
  | (ContentBase & { type: 'bulletedList'; content: BulletItem[] });

export enum Announcements {
  testModal = 'First Test Modal',
  newProjectFlow = 'New Project Flow',
  cs25 = 'CivilSearch 2.5 - Released',
  myProjects = 'My Projects',
  metadataLabels = 'Metadata Labels',
  projectTiers = 'Project Tiers',
}

export const testAnnouncement: Announcement = {
  name: Announcements.testModal,
  content: [
    {
      title: 'Introducing a New Project Flow',
      message:
        'We have made some changes to the platform to make it easier for you to use. Watch the video below to see what has changed.',
      type: 'loom',
      content: 'https://www.loom.com/embed/80a46fe39f4a46b49f89e70847fd5696?sid=c9459855-8d6e-471c-9a58-33de912f1fef',
    },
    {
      title: 'New Project Flow -- Step 1',
      message:
        'With Intelligence, you can see how your organization is performing in real-time. Check out the image below to see how it works.',
      type: 'image',
      content: '/intelligence.gif',
    },
    {
      title: 'New Features Overview',
      message: 'Check out our latest platform enhancements:',
      type: 'bulletedList',
      content: [
        {
          title: 'Improved Dashboard',
          bullets: ['Real-time data visualization', 'Customizable widgets', 'Performance metrics at a glance'],
        },
        {
          title: 'Enhanced Security',
          bullets: ['Two-factor authentication', 'End-to-end encryption', 'Regular security audits'],
        },
      ],
    },
  ],
  buttons: [
    {
      name: 'Support Page',
      link: 'https://portal.usepylon.com/civilgrid/login?kbUrl=https%3A%2F%2Fcivilgrid.help.usepylon.com%2F',
      linkType: 'external',
    },
  ],
};

export const projectTiersAnnouncement: Announcement = {
  name: Announcements.projectTiers,
  modalClassName: 'w-5/6',
  content: [
    {
      title: '🎉 New Project Tiers - Lite and Plus',
      message: (
        <div>
          <span>
            We've launched two new tiers to help you get more out of CivilGrid - at every stage of your project!
          </span>

          <ul className="my-4 list-inside list-disc">
            <li>
              <span className="font-semibold">Project Lite</span> - This tier includes complete utility repository,
              one-click proposal generator, mobile field tools, and more — at a lower cost
            </li>
            <li>
              <span className="font-semibold">Project Plus</span> - Unlock unlimited digitization of all supplemental
              maps and as-builts that are received via our premium CivilSearch service
            </li>
          </ul>

          <span>Have questions or want a walkthrough? We're here to help — just reach out anytime!</span>
        </div>
      ),
      type: 'jsx',
      content: <ProjectPricingTable />,
    },
  ],
  buttons: [],
  expiration: DateTime.local(2025, 5, 15),
};
